import {
    createEntityAdapter,
    createSlice,
} from '@reduxjs/toolkit';

import type { Variant, Variants } from '@amplitude/experiment-js-client';

type VariantWithId = Variant & { id: string };

const variantsAdapter = createEntityAdapter<VariantWithId>();

type VariantsState = ReturnType<typeof variantsAdapter.getInitialState>;
type VariantsStateWithFetch = VariantsState & {
    hasFetched: boolean;
}

export interface RootState {
    i18n: {
        currency: string;
        locale: string;
        supportedCurrencies: [];
        supportedLocales: [];
    };
    variants: VariantsStateWithFetch;
}

const variantsSlice = createSlice({
    initialState: {
        ...variantsAdapter.getInitialState(),
        hasFetched: false,
    },
    name: 'variants',
    reducers: {
        variantsFetchFailed(state) {
            state.hasFetched = true;
        },
        variantsReceived(state, action) {
            const variants = Object.entries(action.payload.variants as Variants)
                .map(([variantName, variant]) => {
                    return {
                        ...variant,
                        id: variantName,
                    };
                });

            variantsAdapter.setAll(state, variants);
            state.hasFetched = true;
        },
    },
});

const selectors = {
    ...variantsAdapter.getSelectors<RootState>(
        (state) => state.variants,
    ),
    selectHasFetched: (state: RootState) => state.variants.hasFetched,
};

const { actions } = variantsSlice;

export const { variantsFetchFailed, variantsReceived } = actions;

export { actions, selectors };
export default variantsSlice.reducer;
